import { Capacitor } from '@capacitor/core'
import { supabase, supabaseReady } from './supabase'

/**
 * Registers the device for push notifications and stores the token in Supabase.
 * No-op on the web (only runs inside the native iOS/Android app), so importing
 * this never affects the web build. Called once per signed-in session.
 */
export async function initPush(userId: string, athleteId: string | null) {
  if (!Capacitor.isNativePlatform() || !supabaseReady) return

  // Dynamic import keeps the plugin out of the web bundle.
  const { PushNotifications } = await import('@capacitor/push-notifications')

  const perm = await PushNotifications.checkPermissions()
  let status = perm.receive
  if (status === 'prompt' || status === 'prompt-with-rationale') {
    status = (await PushNotifications.requestPermissions()).receive
  }
  if (status !== 'granted') return

  // Fires with the device token once registration succeeds.
  await PushNotifications.removeAllListeners()
  PushNotifications.addListener('registration', async (token) => {
    try {
      await supabase.from('push_tokens').upsert(
        {
          user_id: userId,
          athlete_id: athleteId,
          token: token.value,
          platform: Capacitor.getPlatform(),
          updated_at: new Date().toISOString(),
        },
        { onConflict: 'token' }
      )
    } catch {
      /* best effort */
    }
  })

  PushNotifications.addListener('registrationError', (e) => {
    console.warn('[push] registration error', e)
  })

  await PushNotifications.register()
}
